/** Thẻ thành viên / điểm thưởng. Real /api/v1/patients/{id}/loyalty. */
import { apiClient } from "./client";

export interface LoyaltyAccount {
  pointsBalance: number;
  lifetimePoints: number;
  tier: string;
}

export interface LoyaltyTxn {
  kind: "EARN" | "REDEEM" | "ADJUST";
  points: number;
  reason: string | null;
  at: string;
}

export const loyaltyApi = {
  account(patientId: string): Promise<LoyaltyAccount> {
    return apiClient
      .get<LoyaltyAccount>(`/v1/patients/${patientId}/loyalty`)
      .then((r) => r.data);
  },
  transactions(patientId: string): Promise<LoyaltyTxn[]> {
    return apiClient
      .get<LoyaltyTxn[]>(`/v1/patients/${patientId}/loyalty/transactions`)
      .then((r) => r.data);
  },
  earn(patientId: string, points: number, reason: string): Promise<void> {
    return apiClient
      .post(`/v1/patients/${patientId}/loyalty/earn`, { points, reason })
      .then(() => undefined);
  },
  redeem(patientId: string, points: number, reason: string): Promise<void> {
    return apiClient
      .post(`/v1/patients/${patientId}/loyalty/redeem`, { points, reason })
      .then(() => undefined);
  },
};

export const loyaltyQueryKeys = {
  account: (patientId: string) => ["loyalty-account", patientId] as const,
  txns: (patientId: string) => ["loyalty-txns", patientId] as const,
};
